import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
    selector: 'app-upload-license-token',
    templateUrl: './upload-license-token.component.html',
    styleUrls: ['./upload-license-token.component.css']
})
export class UploadLicenseTokenComponent implements OnInit {
    public token: any;
    public frontImage: any = {};
    public backImage: any = {};

    public errorTitle = '';
    public errorId = 'UploadMessage';
    public errorMessageA = '';
    public errorMessageB = '';
    public errorMessageC = '';
    public errorMessageBClass = '';
    public dialogClass = '';
    private uploadError = true;

    constructor(
        private route: ActivatedRoute,
        private connectionService: ConnectionService,
        public router: Router
    ) { }

    ngOnInit() {
        this.token = this.route.snapshot.queryParams.token;
        console.log(this.token);
    }

    fileChangeEvent(inputFile: any, isFront: boolean) {
        var formatBytes = function (a: any, b: any) { if (0 == a) return "0 Bytes"; var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]; };

        var droppedFiles = inputFile.target.files;
        var setImage = function (image: any) {
            if (isFront) {
                this.frontImage = { file: image };
            } else {
                this.backImage = { file: image };
            }
        }.bind(this);

        var getBase64 = function (file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                var fileReaded = {
                    name: file.name,
                    size: formatBytes(file.size, 0),
                    rawSize: file.size,
                    type: file.type,
                    data: reader.result,
                    remove: 'remove'
                };
                setImage(fileReaded);
                console.log({ file: fileReaded });
            };
            reader.onerror = function (error) {
            };
        };

        $.each(droppedFiles, function (i: any, file: any) {
            getBase64(file);
        });

        $(inputFile.target).val('');
    }

    onContinueClick() {
        const data = [
            { name: this.frontImage.file.name, documentB: this.frontImage.file.data.substr(this.frontImage.file.data.indexOf(',') + 1) },
            { name: this.backImage.file.name, documentB: this.backImage.file.data.substr(this.backImage.file.data.indexOf(',') + 1), }
        ];
        const promise = new Promise((resolve, reject) => {
            this.connectionService.postRequestWithToken(
                environment.gateway + 'saveDocument/upload-license', data, 'application/json', this.token).subscribe(
                    (data: any) => {
                        this.errorTitle = 'CONGRATULATIONS!';
                        this.errorMessageA = 'The license images were uploaded.';
                        this.errorMessageB = '';
                        this.errorMessageC = '';
                        this.errorMessageBClass = '';
                        this.dialogClass = 'w450';
                        this.uploadError = false;
                        $('#errorModalDialogUploadMessage').modal();
                        resolve(data);
                    },
                    (error: any) => {
                        this.errorTitle = 'Sorry, we found a problem';
                        this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
                        this.errorMessageB = error.error.msg;
                        this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                        this.errorMessageBClass = 'mB20';
                        this.dialogClass = 'w600';
                        this.uploadError = true;
                        $('#errorModalDialogUploadMessage').modal();
                        reject(error.error);
                    }
                );
        });
        return promise;
    }

    onCloseModal() {
        if (!this.uploadError) {
            this.router.navigateByUrl('/');
        }
    }

}
